import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class Customer extends Base {
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  list(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/cmms/customer?" + queryParam);
    return this._secureFetch(url);
  }


  delete(id) {
    const url = this._getFullURL("/cmms/customer/"+id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }



  create2(payload, photoFile) {
    const url = this._getFullURL("/cmms/customer");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("filePhoto", photoFile);

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }
  getOne(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/cmms/customer?" + queryParam);
    return this._secureFetch(url);
  }

  update(id, payload) {
    const url = this._getFullURL("/cmms/customer?id=" + id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  import(payload) {
    const url = this._getFullURL("/cmms/customer/import");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
}
